export const SET_USERS = 'users/SET_USERS';
export const SET_FETCHING_USERS = 'users/SET_FETCHING_USERS';
